
import React from 'react';
import './sideMenu.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaInstagram, FaTiktok, FaFacebook, FaPinterest, FaTumblr, FaDeviantart } from 'react-icons/fa';

function SideMenu(){
  return (
    <div className="sidebar-header">
      <nav className="nav-menu">
        <a href="https://www.instagram.com/iulianamihai" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="icon" />
          </a>
          <a href="https://www.tiktok.com/@iuliana.mihai" target="_blank" rel="noopener noreferrer">
            <FaTiktok className="icon" />
          </a>
          <a href="https://www.facebook.com/IM.iulianamihai/" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="icon" />
          </a>
          <a href="https://ro.pinterest.com/iulianamihaii/" target="_blank" rel="noopener noreferrer">
            <FaPinterest className="icon" />
          </a>
          <a href="https://www.tumblr.com/iulianamihaii" target="_blank" rel="noopener noreferrer">
            <FaTumblr className="icon" />
          </a>
          <a href="https://www.deviantart.com/nebunelli" target="_blank" rel="noopener noreferrer">
            <FaDeviantart className="icon" />
          </a>
      </nav>
    </div>
  );
}

export default SideMenu;